import { FormattedMessage } from '@flipster/i18n';
import { Badge } from '@flipster/react/design-system/badge';
import ShieldStarIcon from '@flipster/react/icon/generated/ShieldStarIcon';

export const CopyMasterBadge = () => {
  return (
    <Badge type='tint' color='neutral' leadingIcon={<ShieldStarIcon />} css={{ color: 'content.accent.VIP' }}>
      <FormattedMessage id='Autogen_common.r251126.s_Copy_master' />
    </Badge>
  );
};
